import { container } from '@shared/common/dependency-injection/domain/container';
import type { CurrentClientUserSelectionService } from '@client/entity/current-client-user/domain/service/current-client-user-selection.service';
import { CurrentClientUserDependencyTypes } from '@client/entity/current-client-user/current-client-user.dependency-types';
import { useCurrentClientUserStore } from '@client/entity/current-client-user/application/store/current-client-user.store';

let mainLayoutInitPromise: Promise<void> | null = null;

export async function ensureSelectedClientIsInitializedGuard(): Promise<true> {
  const currentClientUserStore = useCurrentClientUserStore();

  if (currentClientUserStore.selectedClient) {
    return true;
  }

  if (!currentClientUserStore.definedCurrentClientUser.clients.length) {
    return true;
  }

  if (!mainLayoutInitPromise) {
    mainLayoutInitPromise = (async () => {
      const clientSelectionService = container.get<CurrentClientUserSelectionService>(
        CurrentClientUserDependencyTypes.CurrentClientUserSelectionService,
      );
      clientSelectionService.ensureSelectedClient();
    })().finally(() => {
      mainLayoutInitPromise = null;
    });
  }

  await mainLayoutInitPromise;

  return true;
}
